var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { TourInnerContext } from "./TourProvider";
import { processMove } from "./processMove";
var SAFETY_EMPTY_INDEX = 10000;
//todo: avoid extra rerendering
var TourComponent = /** @class */ (function (_super) {
    __extends(TourComponent, _super);
    function TourComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            stepIndex: 0,
            active: false,
        };
        _this.processSteps = function (children) {
            var steps = React.Children.toArray(children);
            return steps.sort(function (a) {
                return "isFallback" in a.props && a.props.isFallback ? 1 : 0;
            });
        };
        _this.run = function () {
            var firstStep = _this.steps[0];
            var onOpen = function () {
                var _a, _b, _c, _d, _e, _f;
                if ((_b = (_a = firstStep.props).anchorElement) === null || _b === void 0 ? void 0 : _b.call(_a)) {
                    (_d = (_c = _this.props).onOpen) === null || _d === void 0 ? void 0 : _d.call(_c);
                }
                (_f = (_e = firstStep.props).onOpen) === null || _f === void 0 ? void 0 : _f.call(_e);
            };
            var onBefore = firstStep.props.onBefore;
            if (onBefore) {
                return onBefore().then(function () {
                    _this.showTour(onOpen);
                });
            }
            _this.showTour(onOpen);
        };
        _this.showTour = function (clb) {
            _this.setState({ active: true, stepIndex: 0 }, function () { return clb && clb(); });
        };
        _this.updateIndex = function (index) {
            _this.setState({ stepIndex: index }, function () {
                if (_this.state.stepIndex === _this.steps.length && _this.props.onClose) {
                    _this.props.onClose();
                }
            });
        };
        _this.handleNext = function () { return _this.move(_this.state.stepIndex, function (a, b) { return a + b; }); };
        _this.handlePrev = function () { return _this.move(_this.state.stepIndex, function (a, b) { return a - b; }); };
        _this.move = function (ind, moveFunc) {
            var nextStep = _this.steps[moveFunc(ind, 1)];
            if (nextStep &&
                "isFallback" in nextStep.props &&
                nextStep.props.isFallback) {
                _this.move(moveFunc(ind, 1), moveFunc);
            }
            else {
                _this.moveTo(moveFunc(ind, 1), ind);
            }
        };
        _this.moveTo = function (ind, prevInd) {
            var step = _this.steps[ind];
            var prevStep = _this.steps[prevInd];
            processMove(prevStep, step, function () {
                _this.updateIndex(ind);
                step && step.props.onOpen && step.props.onOpen();
            }, function () { return _this.updateIndex(SAFETY_EMPTY_INDEX); });
        };
        _this.handleClose = function () {
            var stepIndex = _this.state.stepIndex;
            var hasFallbackStepToGo = _this.fallbackStepIndex >= 0 &&
                _this.fallbackStepIndex !== stepIndex &&
                stepIndex + 1 < _this.fallbackStepIndex;
            if (hasFallbackStepToGo) {
                _this.moveTo(_this.fallbackStepIndex, stepIndex);
            }
            else {
                _this.moveTo(_this.steps.length, stepIndex);
            }
        };
        //todo: warning for two final steps
        _this.steps = _this.processSteps(props.children);
        _this.fallbackStepIndex = _this.steps.findIndex(function (step) { return "isFallback" in step.props && step.props.isFallback; });
        return _this;
    }
    TourComponent.prototype.componentDidMount = function () {
        this.run();
    };
    TourComponent.prototype.componentWillReceiveProps = function (nextProps) {
        this.steps = this.processSteps(nextProps.children);
    };
    TourComponent.prototype.render = function () {
        if (!this.state.active) {
            return null;
        }
        var stepIndex = this.state.stepIndex;
        var step = this.steps[stepIndex];
        var stepsCount = this.steps.length;
        var currentStepWithProps = step &&
            React.cloneElement(step, {
                onClose: this.handleClose,
                onNext: this.handleNext,
                onPrev: this.handlePrev,
                onSkip: this.props.onSkip,
                onContinue: this.props.onContinue,
                stepIndex: this.state.stepIndex,
                stepsCount: this.fallbackStepIndex !== -1 ? stepsCount - 1 : stepsCount,
                blueBackground: this.props.blueBackground,
            });
        return React.createElement("div", null, currentStepWithProps);
    };
    return TourComponent;
}(React.Component));
export { TourComponent };
var Tour = /** @class */ (function (_super) {
    __extends(Tour, _super);
    function Tour() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showTour: false };
        _this.handleOpen = function () { return _this.context.onOpen(_this.props.id); };
        _this.run = function () { return _this.setState({ showTour: true }); };
        _this.hide = function () { return _this.setState({ showTour: false }); };
        _this.unsubscribe = function () {
            if (_this.context.unsubscribe) {
                _this.context.unsubscribe(_this.props.id);
            }
        };
        _this.subscribe = function () {
            if (_this.context.subscribe) {
                _this.context.subscribe(_this.props.id, { run: _this.run, hide: _this.hide }, !!_this.props.excludeFromQueue);
            }
        };
        _this.closeTour = function () {
            _this.setState({ showTour: false }, function () {
                _this.props.onClose && _this.props.onClose();
                if (_this.context.onShown) {
                    _this.context.onShown(_this.props.id).then(_this.unsubscribe);
                }
            });
        };
        return _this;
    }
    Tour.prototype.render = function () {
        return this.state.showTour ? (React.createElement(TourComponent, __assign({}, this.props, { children: this.props.children, onClose: this.closeTour, onSkip: this.unsubscribe, onContinue: this.subscribe, onOpen: this.handleOpen }))) : null;
    };
    Tour.prototype.componentDidMount = function () {
        this.subscribe();
    };
    Tour.prototype.componentWillUnmount = function () {
        this.unsubscribe();
    };
    Tour.contextType = TourInnerContext;
    return Tour;
}(React.Component));
export { Tour };
